import CompanyLogo from "assets/aktos-logo-1004x923.png";
import { useWhiteLabel } from "providers/whiteLabelProvider";
import styled from "styled-components";

const StyledImg = styled.img`
  margin-top: -36px;
  display: none;
  @media (max-width: 768px) {
    display: flex;
    justify-self: center;
    margin-inline: auto;
  }
`;

/**
 * A logo for the auth pages in mobile forms
 */

function AuthMobileLogo() {
  const { isWhiteLabeled, logo } = useWhiteLabel();

  return <StyledImg src={isWhiteLabeled ? logo : CompanyLogo} alt="Mini Logo" width={100} />;
}

export default AuthMobileLogo;
